export default "__VITE_ASSET__COgVE5vY__"